export default __webpack_public_path__ + "static/media/privacy-policy.f46733e7.pdf";